<template>
	<main class="home-main">
		<div class="grid grid-cols-1 lg:grid-cols-5 h-full">
			<section class="col-span-3">
				<div class="main-banner">
					<div class="banner-text">
						What is MC RWE?
					</div>
				</div>
				<article class="px-8 md:px-16 xl:px-24 py-6 md:py-12 content">
					<p>
						<strong>M</strong>edical <strong>C</strong>annabis <strong>R</strong>eal <strong>Wo</strong>rld <strong>E</strong>vidence is a research study to understand the effects of medical cannabis over 6 months in adult patients with chronic pain, epilepsy or issues with sleep, anxiety or depression
					</p>
					<p>
						Patients use medical cannabis products available on MyMedi.ca website
					</p>
					<p>
						Patients track their symptoms- using standard questionnaires
					</p>
					<div class="indicator-wrapper">
						<font-awesome-icon :icon="['fas', 'angle-double-down']" class="fa-2x"/>
					</div>
				</article>
			</section>
			<section class="bg-black-blue col-span-2">
				<div class="secondary-banner">
					<div class="banner-text">
						Why should I participate?
					</div>
				</div>
				<article class="px-8 md:px-16 xl:px-24 pt-2 pb-16 md:py-12 content text-white">
					<p>
						This is the first study of its kind and will include patients from across Canada! It will give researchers valuable information on the use of medical cannabis as a treatment option.
					</p>
					<div class="page-links mt-12">
						<div class="patient-link">
							<router-link to="/patients">I am a patient</router-link>
						</div>
						<div class="professionals-link">
							<router-link to="/healthcare-professionals">I am a healthcare professional</router-link>
						</div>
					</div>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
export default {
	name: 'Home',
	components: {}
}
</script>

<style lang="postcss" scoped>
	.home-main {
		height: auto;
		background-color: #fff;
	}
	.main-banner {
		width: 100%;
		height: 175px;
		display: flex;
		align-items: center;
		background-image:
		linear-gradient(to top right, rgba(134, 158, 51, 0.5), rgba(38, 156, 189, 0.75)),
		url('../assets/images/1x/home-banner.jpg');
		background-position: 35% center;
		background-repeat: no-repeat;
		.banner-text {
			width: 80%;
			margin-left: 2rem;
			padding-bottom: 1rem;
			border-bottom: 3px solid #fff;
			color: #fff;
			font-size: 1.75rem;
			text-align: left;
		}
	}
	.indicator-wrapper {
		display: flex;
		justify-content: center;
		padding: 1rem 0 1.5rem;
		color: theme('colors.dark-grey');
		svg {
			animation: scrollDown 1.5s ease-in-out infinite;
		}
	}
	@keyframes scrollDown {
		0% {
			opacity: 1;
			transform: translateY(0%);
		}
		100% {
			opacity: 0;
			transform: translateY(50%);
		}
	}
	.secondary-banner {
		width: 100%;
		height: 175px;
		display: flex;
		align-items: center;
		.banner-text {
			width: 80%;
			margin-left: 2rem;
			padding-bottom: 1rem;
			border-bottom: 3px solid #fff;
			color: #fff;
			font-size: 1.75rem;
			text-align: left;
			white-space: nowrap;
		}
	}
	.content {
		text-align: left;
		p:not(:first-of-type) {
			padding: 0.3rem 0;
		}
	}
	.page-links {
		font-family: theme(fontFamily.arial-bold);
		font-size: 1.75rem;
		> :not(:first-of-type) {
			padding: 1rem 0 0 0;
		}
		.patient-link {
			color: theme('colors.olive-green-alt');
		}
		.professionals-link {
			color: theme('colors.cyan');
		}
	}
	@media screen and (min-width: 640px) {
		.home-main {
			height: 100%;
		}
		.main-banner, .secondary-banner {
			.banner-text {
				margin-left: 4rem;
			}
		}
	}
	@media screen and (min-width: 769px) {
		.indicator-wrapper {
			display: none;
		}
	}

	@media screen and (min-width: 1024px) {
		.home-main {
			height: 700px;
		}
		.main-banner {
			.banner-text {
				width: 100%;
				margin-left: 6rem;
			}
		}
		.secondary-banner {
			.banner-text {
				width: 100%;
				margin-right: 5rem;
				margin-left: 0;
				padding-left: 4rem;
			}
		}
	}
	@media screen and (min-width: 1440px) {
		.secondary-banner {
			.banner-text {
				padding-left: 6rem;
			}
		}
	}
</style>
